<mat-form-field>
  <mat-label>Apply a Workflow</mat-label>
  <mat-select [(value)]="workflowId" name="selectedWorkflow-select">
    @if (workflows.length !== 0) {
      <mat-option>
        <ngx-mat-select-search [formControl]="workflowFilterCtrl" placeholderLabel="Search..." noEntriesFoundLabel="No matches"></ngx-mat-select-search>
      </mat-option>
    }
    @if (filteredWorkflows.length === 0) {
      <mat-option
        class="full-option-text"
        value="null"
        >
        You dont't have any Secondary Templates.
        Please go to Templates to create one.
      </mat-option>
    } @else {
      @for (item of filteredWorkflows; track item) {
        <mat-option class="full-option-text" [value]="item.id">
          {{item.name}}
        </mat-option>
      }
    }
  </mat-select>
</mat-form-field>